(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9589],{

/***/ 95885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/[slug]",
      function () {
        return __webpack_require__(69057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function CardCTA(param) {
    var className = param.className, label = param.label;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('rounded border border-rose py-2 px-4 text-sm font-bold text-rose group-hover:border-cornflower group-hover:text-cornflower', className),
        children: [
            label,
            " →"
        ]
    }));
};


/***/ }),

/***/ 45113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46831);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_resolvers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16019);
/* harmony import */ var _components_DefaultCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16190);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CardGrid(param) {
    var entries = param.entries, _Component = param.Component, Component = _Component === void 0 ? _components_DefaultCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : _Component, linkSubpath = param.linkSubpath, truncatedText = param.truncatedText;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "-mx-6 flex flex-wrap",
        children: entries.map(function(entry) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-12 flex w-full px-6 md:w-1/2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, entry, {
                    subTitle: truncatedText ? (0,_utils_resolvers__WEBPACK_IMPORTED_MODULE_3__/* .truncateText */ .a)({
                        text: entry.subTitle
                    }) : entry.subTitle,
                    linkPath: "/".concat(linkSubpath, "/").concat(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1___default()(entry.slug, {
                        lower: true
                    }))
                }))
            }, entry.id);
        })
    }));
};


/***/ }),

/***/ 83228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function CardLink(param) {
    var children = param.children, className = param.className, externalUrl = param.externalUrl, linkPath = param.linkPath;
    var linkClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex flex-1 flex-col group');
    if (externalUrl) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: externalUrl,
            target: "_blank",
            rel: "nofollow noopener noreferrer",
            className: linkClassName,
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: linkPath,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: linkClassName,
            children: children
        })
    }));
};


/***/ }),

/***/ 14264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var _components_Hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52456);
/* harmony import */ var _components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89338);
/* harmony import */ var _components_Pill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79506);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67576);
/* harmony import */ var _components_ContentWithTOC__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12590);
/* harmony import */ var _components_RelatedContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88682);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var DynamicShareSheetWithNoSSR = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(1826)]).then(__webpack_require__.bind(__webpack_require__, 63047));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63047)
            ];
        }
    },
    ssr: false
});
function ContentPage(param1) {
    var page = param1.page, relatedContent = param1.relatedContent, type = param1.type, linkSubpath = param1.linkSubpath;
    if (!page) return null;
    var pagesWithTOC = [
        'AcademyPost',
        'CaseStudy'
    ];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Section__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, page, {
                        children: type === 'blog' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "-mx-1 -my-1 flex flex-wrap items-center justify-center",
                            children: page.categories.map(function(param, index) {
                                var title = param.title, slug = param.slug;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/blog/tag/".concat(slug),
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Pill__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            label: title,
                                            size: "large"
                                        })
                                    })
                                }, index);
                            })
                        })
                    })),
                    pagesWithTOC.includes(page.__typename) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContentWithTOC__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        page: page,
                        togglerRequired: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({}, page))
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto h-auto max-w-3xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({}, page))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-6 flex items-center justify-between md:-mr-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 h-1 w-24 rounded border-0 bg-cornflower md:my-12 md:block md:w-48"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicShareSheetWithNoSSR, {
                                title: page.title
                            })
                        ]
                    })
                ]
            }),
            relatedContent && relatedContent.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RelatedContent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                relatedContent: relatedContent,
                linkSubpath: linkSubpath
            })
        ]
    }));
};


/***/ }),

/***/ 12590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentWithTOC; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_TOC__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93335);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ContentWithTOC(_param) {
    var page = _param.page, togglerRequired = _param.togglerRequired, _wrapperClass = _param.wrapperClass, wrapperClass = _wrapperClass === void 0 ? '' : _wrapperClass, children = _param.children, props = _objectWithoutProperties(_param, [
        "page",
        "togglerRequired",
        "wrapperClass",
        "children"
    ]);
    var h2Regexp = /^(## .*[\n\r\v\t\s]*)$/gim;
    var contentHeading2 = page.content.match(h2Regexp);
    var links = contentHeading2 ? contentHeading2.map(function(link) {
        return link.slice(3);
    }) : [];
    var isCustomerPresent = page.customer !== undefined;
    var sectionClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClass, 'max-w-3xl mx-auto xl:flex xl:flex-nowrap xl:flex-row');
    var asideClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()('w-full mt-8 max-h-screen xl:order-first xl:sticky xl:-ml-60 xl:mr-12 xl:w-56 xl:self-start', {
        'mb-16': isCustomerPresent
    });
    if (!links.length) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: sectionClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", {
                className: asideClass,
                style: {
                    top: '160px'
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TOC__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
                    links: links,
                    togglerRequired: togglerRequired
                }, props))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "xl:order-last xl:max-w-3xl xl:flex-grow",
                children: children
            })
        ]
    }));
};


/***/ }),

/***/ 16190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37324);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27910);
/* harmony import */ var _components_CardLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83228);
/* harmony import */ var _components_CardCTA__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13690);






function DefaultCard(param) {
    var coverImage = param.coverImage, externalUrl = param.externalUrl, linkPath = param.linkPath, id = param.id, subTitle = param.subTitle, title = param.title;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: "flex flex-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_CardLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            externalUrl: externalUrl,
            linkPath: linkPath,
            children: [
                coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "rounded-lg",
                        src: coverImage.url,
                        width: coverImage.width,
                        height: coverImage.height,
                        alt: coverImage === null || coverImage === void 0 ? void 0 : coverImage.alt
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "-mt-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        level: 4,
                        className: "mb-2",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "flex-grow",
                    children: subTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardCTA__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        label: "Learn More"
                    })
                })
            ]
        })
    }, id));
};


/***/ }),

/***/ 88682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RelatedContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_CardGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45113);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67576);
/* harmony import */ var _components_SectionHero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38790);




function RelatedContent(param) {
    var entries = param.relatedContent, linkSubpath = param.linkSubpath;
    if (!entries || !entries.length || !linkSubpath) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        colour: "light",
        size: "small",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionHero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                noHr: true,
                title: "Related"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardGrid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                entries: entries,
                linkSubpath: linkSubpath
            })
        ]
    }));
};


/***/ }),

/***/ 93335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TOC; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46831);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_renderers_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31515);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27910);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68663);
/* harmony import */ var _svg_icons_remix_arrow_down_line_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46396);








function TOC(param) {
    var links = param.links, togglerRequired = param.togglerRequired, textSizes = param.textSizes, heading = param.heading;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isOpen = ref[0], setOpen = ref[1];
    var toggleNav = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(function(status) {
            return !status;
        });
    }, []);
    var headingClass = "font-black leading-snug text-xl pt-8 px-12 md:px-8 md:text-lg lg:px-6 xl:text-xl";
    var ulClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()('list-none px-12 pb-6 w-full', {
        'pt-2 md:pl-8 md:pr-4 lg:pl-6': isOpen,
        'xl:p-0': !isOpen
    });
    var liClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()('hover:underline leading-tight my-4 xl:my-2', {
        'xl:invisible xl:h-0': !isOpen
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: "relative mb-6 box-border w-full rounded-md bg-gray-200",
        children: [
            togglerRequired === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "xl:w-full",
                colour: "purple",
                appearance: "outline",
                onClick: toggleNav,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            level: 4,
                            className: headingClass,
                            children: heading || 'Table of contents'
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_remix_arrow_down_line_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "h-4 w-5 transform fill-current transition-transform duration-100 xl:order-last ".concat(isOpen && '-rotate-90')
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: headingClass,
                children: heading || 'Table of contents'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: ulClass,
                children: links.map(function(link, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: liClass,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: textSizes ? classnames__WEBPACK_IMPORTED_MODULE_2___default()('text-cornflower', textSizes) : 'text-base text-cornflower xl:text-sm',
                            href: "#".concat(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default()(link, {
                                customReplacements: [
                                    [
                                        '/',
                                        ''
                                    ],
                                    [
                                        '.',
                                        ''
                                    ], 
                                ],
                                decamelize: false
                            })),
                            children: link
                        })
                    }, index);
                })
            })
        ]
    }));
};


/***/ }),

/***/ 69057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ AcademyContentTemplate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45363);
/* harmony import */ var _components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1635);
/* harmony import */ var _components_ContentPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14264);
/* harmony import */ var _utils_serializeJsonLd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66096);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __N_SSG = true;
function AcademyContentTemplate(param) {
    var relatedContent = param.relatedContent, academyPost = param.academyPost, slug = param.slug, preview = param.preview;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        seo: academyPost,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", _objectSpread({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_2__/* .jsonLdScriptProps */ .h6)({
                    '@context': 'https://schema.org',
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': "https://graphcms.com/academy/".concat(slug)
                    },
                    headline: (0,_utils_serializeJsonLd__WEBPACK_IMPORTED_MODULE_5__/* .serialize */ .q)(academyPost.title),
                    image: academyPost.coverImage.url,
                    articleSection: 'Academy',
                    keywords: 'academy,graphcms',
                    datePublished: academyPost.publishedAt,
                    dateModified: academyPost.updateAt || academyPost.publishedAt,
                    publisher: {
                        '@type': 'Organization',
                        name: 'GraphCMS',
                        logo: {
                            '@type': 'ImageObject',
                            url: 'https://graphcms.com/logo.png'
                        }
                    },
                    description: (0,_utils_serializeJsonLd__WEBPACK_IMPORTED_MODULE_5__/* .serialize */ .q)(academyPost.subTitle)
                })))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContentPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                relatedContent: relatedContent,
                page: academyPost,
                linkSubpath: "academy"
            })
        ]
    }));
};


/***/ }),

/***/ 16019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ truncateText; }
/* harmony export */ });
function truncateText(param) {
    var text = param.text, _length = param.length, length = _length === void 0 ? 24 : _length;
    if (!text) return null;
    var splitText = text.split(" ");
    if (splitText.length < length) return text;
    return "".concat(splitText.splice(0, length).join(" "), "...");
}


/***/ }),

/***/ 66096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
function serialize(target) {
    return JSON.stringify(target).slice(1, -1);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,8009,6831,5343,1635,2456,9338,9774,2888,179], function() { return __webpack_exec__(95885); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);